import React from 'react';
import PropTypes from 'prop-types';
import DownloadFile from './components/DownloadChartData/DownloadFile';
import {formatCsv, formatTsv} from './helper';
import themeable from 'zignal-landscape/lib/themeable';

const Menu =  ({
  styles,
  fileNameWithoutExtension,
  getAuthorsAndStories,
  exportFileName,
}) => {
  return (
    <ol className={styles.menuList}>
      <li className={styles.menuOption}>
        <DownloadFile
          getData={() => formatTsv(getAuthorsAndStories())}
          fileType={`${exportFileName} TSV`}
          fileName={`${fileNameWithoutExtension}.tsv`}
        />
      </li>
      <li className={styles.menuOption}>
        <DownloadFile
          getData={() => formatCsv(getAuthorsAndStories())}
          fileType={`${exportFileName} CSV`}
          fileName={`${fileNameWithoutExtension}.csv`}
        />
      </li>
    </ol>
  );

};

Menu.propTypes = {
  styles: PropTypes.object.isRequired,
  getAuthorsAndStories: PropTypes.func.isRequired,
  fileNameWithoutExtension: PropTypes.string.isRequired,
  exportFileName: PropTypes.string.isRequired,
};

export default themeable(Menu);
